import { render, staticRenderFns } from "./AppNav.vue?vue&type=template&id=54eb675e&"
import script from "./AppNav.vue?vue&type=script&lang=js&"
export * from "./AppNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54eb675e')) {
      api.createRecord('54eb675e', component.options)
    } else {
      api.reload('54eb675e', component.options)
    }
    module.hot.accept("./AppNav.vue?vue&type=template&id=54eb675e&", function () {
      api.rerender('54eb675e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/AppNav.vue"
export default component.exports